import { DocumentPreview } from "@neonumy/documents-preview";

interface PreviewDocumentProps {
  previewDocumentUrl: string;
  onClickGoBack?: () => void;
  downloadFilename?: string;
  loading?: boolean;
}

export default function DocumentViewer({
  previewDocumentUrl,
  onClickGoBack,
  downloadFilename,
  loading,
}: PreviewDocumentProps) {
  return (
    <DocumentPreview
      defaultZoom={130}
      thumbnails={false}
      wheelZoom={true}
      fileUrl={previewDocumentUrl}
      isPDF={true}
      onClickGoBack={onClickGoBack}
      downloadFilename={downloadFilename}
      loading={loading}
    />
  );
}
